import React from 'react';
import { useHistory } from 'react-router-dom';
import styled from '@emotion/styled';
import COLORS from '../../theme/Colors';
import { StyledButton, StyledButtonOutlined } from '../../theme/Styles';
import FONTS_FAMILY from '../../theme/FontsFamily';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  padding: 2rem;
  text-align: center;
  background-color: #fff;
`;

const ErrorCode = styled.h1`
  font-size: 10rem;
  font-weight: 800;
  color: ${COLORS.secondary};
  margin: 0;
  line-height: 1;
  font-family: ${FONTS_FAMILY.bold.title};
  opacity: 0.9;

  @media (max-width: 768px) {
    font-size: 6rem;
  }
`;

const Title = styled.h2`
  font-size: 3rem;
  color: ${COLORS.secondary};
  margin: 1rem 0;
  font-family: ${FONTS_FAMILY.bold.title};
  font-weight: 700;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  font-size: 1.25rem;
  color: #64748B;
  max-width: 600px;
  margin-bottom: 3rem;
  font-family: ${FONTS_FAMILY.regular.body};
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1.1rem;
  }
`;

const GhostButton = styled(StyledButtonOutlined)`
  border: 1px solid #E2E8F0;
  background-color: transparent;
  color: #64748B;
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;

  &:hover {
    background-color: #F8FAFC;
    border-color: #CBD5E1;
    color: ${COLORS.secondary};
  }
`;

const PrimaryButton = styled(StyledButton)`
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  background-color: ${COLORS.secondary};
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 1.5rem;
  width: 100%;
  max-width: 500px;
  justify-content: center;

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
`;

const ButtonWrapper = styled.div`
  width: 220px;
  @media (max-width: 600px) {
    width: 100%;
  }
`;

function NotFound() {
  const history = useHistory();

  return (
    <Container>
      <ErrorCode>404</ErrorCode>
      <Title>Página no encontrada</Title>
      <Description>
        Lo sentimos, la página que estás buscando no existe o ha sido movida.
      </Description>
      <ButtonGroup>
        <ButtonWrapper>
          <PrimaryButton 
            onClick={() => history.push('/')}
            startIcon={<HomeIcon />}
          >
            Ir al Inicio
          </PrimaryButton>
        </ButtonWrapper>
        <ButtonWrapper>
          <GhostButton 
            onClick={() => history.goBack()}
            startIcon={<ArrowBackIcon />}
          >
            Volver atrás
          </GhostButton>
        </ButtonWrapper>
      </ButtonGroup>
    </Container>
  );
}

export default NotFound;

